import { ShieldCheck, Scale, FileCheck2, Lock } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";
import { MessageCircle } from "lucide-react";

const WA = "https://wa.me/56936400479?text=Hola%2C%20quiero%20saber%20m%C3%A1s%20sobre%20cumplimiento%20Ley%2021.719";

const pillars = [
  {
    icon: Scale,
    title: "Fuentes públicas legales",
    desc: "Trabajamos únicamente con registros oficiales, datos abiertos del Estado y fuentes legalmente permitidas.",
  },
  {
    icon: FileCheck2,
    title: "Trazabilidad documentada",
    desc: "Cada base incluye documentación de origen, fecha de extracción y actualización.",
  },
  {
    icon: Lock,
    title: "Solo datos empresariales",
    desc: "Manejamos exclusivamente información de carácter B2B y empresarial — no datos personales sensibles.",
  },
];

export default function Compliance() {
  return (
    <section
      id="cumplimiento"
      data-testid={TESTIDS.complianceSection}
      className="relative py-24 lg:py-32 border-t border-[rgba(0,240,255,0.08)] overflow-hidden"
    >
      {/* BG image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/60504/security-protection-anti-virus-software-60504.jpeg"
          alt="Seguridad de datos"
          className="w-full h-full object-cover opacity-10"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#040812] via-[#040812]/95 to-[#040812]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          {/* LEFT */}
          <div className="lg:col-span-5">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[rgba(0,240,255,0.3)] bg-[rgba(0,240,255,0.06)] mb-6">
              <ShieldCheck className="text-[#00f0ff]" size={14} />
              <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#00f0ff]">
                Ley 21.719 · Chile
              </span>
            </div>

            <h2 className="font-display font-black text-white text-4xl sm:text-5xl leading-[1] tracking-tight mb-6">
              En coherencia
              <br />
              con la <span className="italic font-light text-[#00f0ff]">nueva ley</span>
              <br />
              de datos.
            </h2>

            <p className="text-[#94a3b8] text-base leading-relaxed mb-5">
              La Ley 21.719 actualiza el marco de protección de datos personales
              en Chile y entra en vigencia en diciembre de 2026. En Chile Datos
              Pro hemos adaptado nuestros procesos para operar en plena
              coherencia con esta nueva normativa.
            </p>

            <p className="text-[#94a3b8] text-base leading-relaxed mb-8">
              Todos nuestros contactos provienen de{" "}
              <span className="text-white font-semibold">
                fuentes públicas oficiales
              </span>
              , están segmentados como información empresarial (B2B) y se
              entregan con respaldo de origen.
            </p>

            <a
              href={WA}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={TESTIDS.complianceWhatsapp}
              className="inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5a] text-white font-semibold px-6 py-3.5 rounded-full transition-all shadow-[0_12px_40px_-8px_rgba(37,211,102,0.5)] hover:-translate-y-0.5"
            >
              <MessageCircle size={18} />
              Consultar sobre cumplimiento
            </a>
          </div>

          {/* RIGHT */}
          <div className="lg:col-span-7 space-y-4">
            {pillars.map((p) => {
              const Icon = p.icon;
              return (
                <div
                  key={p.title}
                  className="glass-card p-7 flex gap-5 items-start"
                >
                  <div className="w-14 h-14 rounded-2xl bg-[#040812] border border-[rgba(0,240,255,0.4)] flex items-center justify-center shrink-0 shadow-[inset_0_0_20px_rgba(0,240,255,0.15)]">
                    <Icon className="text-[#00f0ff]" size={22} />
                  </div>
                  <div>
                    <h3 className="font-display font-bold text-white text-lg leading-tight mb-2">
                      {p.title}
                    </h3>
                    <p className="text-[14px] text-[#94a3b8] leading-relaxed">
                      {p.desc}
                    </p>
                  </div>
                </div>
              );
            })}

            <div className="mt-6 p-5 rounded-2xl border border-dashed border-[rgba(0,240,255,0.25)] bg-[rgba(0,240,255,0.03)]">
              <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#00f0ff] mb-2">
                Nota legal
              </p>
              <p className="text-[13px] text-[#94a3b8] leading-relaxed">
                Esta sección es informativa. Si tu empresa requiere asesoría
                jurídica específica respecto a la Ley 21.719, te recomendamos
                consultar con un abogado especializado en protección de datos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
